module.exports = __webpack_public_path__ + "img/logo-white.fe3c172e.png";